import { Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import SideBar from "../SideBar/SideBar";
import Certificates from "./Certificates";
import "./Certificates.css";

export default function Certifications(props) {
  return (
    <Container className="h-100 bg-danger" id="certifications" fluid>
      <Row className="h-100">
        <div className="d-none d-md-block bg-dark col-md-1">
          <SideBar active="Certifications" />
        </div>
        <div className="col-md pt-4 bg-dark" id="main-content">
          <div className="d-block text-light d-md-none">
            <h2 className="mt-3 mt-md-5 mb-md-4">
              My <span className="text-danger">Certifications</span>
            </h2>
            <h6 className="mt-2">
              I have completed most of my certifications from coursera or udemy
              and here are some of my certifications
            </h6>
          </div>
          <Certificates />
          <div className="mt-5 d-md-none d-block text-center pb-3 pb-md-0 pt-md-5">
            <div className="mt-md-5 pt-md-5" />
            <Link className="mt-5 pt-md-5 text-light" to="/" id="arrow-down">
              <i className="mt-md-5 pt-md-5 fa-2x fa-solid fa-angles-up"></i>
            </Link>
          </div>
        </div>
        <div className="col-md-4 bg-md-danger d-none d-md-block text-light mt-5">
          <h2 className="mt-3 mt-md-5 mb-md-4">
            My Certifications
          </h2>
          <h6 className="mt-2">
            <span style={{ textIndent: "1rem" }}>
              I have completed most of my certifications from coursera or udemy
              and here are some of my certifications
            </span>
            <span className="d-block d-md-none">
              Below are some of my projects
            </span>
          </h6>
          <div className="mt-5 text-center pb-3 pb-md-0 pt-md-5">
            <div className="mt-md-5 pt-md-5" />
            <Link className="mt-5 pt-md-5 text-light" to="/" id="arrow-down">
              <i className="mt-md-5 pt-md-5 fa-2x fa-solid fa-angles-up"></i>
            </Link>
          </div>
        </div>
      </Row>
    </Container>
  );
}
